<script setup lang="ts">
import { EventMockupsStatus } from "mws-catalog-ts-sdk-v2-admin";

import EventMockupsPaginatedTable from "@/kits/components/EventKitPaginatedTable.vue";

definePage({
  meta: {
    auth: ["Kits.Read"],
  },
});
</script>

<template>
  <EventMockupsPaginatedTable :status="EventMockupsStatus.Complete" />
</template>
